import { TableRow, TableCell, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { Item } from '../../../../app/services/api/generated';
import RoundAndFormatValue from '../../../../components/shared/RoundAndFormatValue';
import { useNavigate } from 'react-router-dom';

type Props = {
  item: Item;
  currencyCode?: string;
  hasAnyReadPermission: boolean;
}

const ItemRow: FC<Props> = ({ item, currencyCode, hasAnyReadPermission }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = () => {
    if (!hasAnyReadPermission) {
      return;
    }

    const sku = item.itemNumber;
    if (!sku) {
      return;
    }

    const params = new URLSearchParams();
    params.set('sku', sku);
    params.set('orderable', 'false');

    navigate(`/store/item/${item.id}?${params.toString()}`);
  };

  return (
    <TableRow
      sx={{ cursor: 'pointer' }}
      onClick={handleClick}>
      <TableCell>
        <Typography variant='textXS'
          fontWeight={600}
          color={theme.palette.primary[500]}
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
          {item.itemNumber}
        </Typography>
      </TableCell>
      <TableCell variant='clampedText'
        sx={{ minWidth: '160px' }}>
        <Typography variant='textXS'>
          {item.description}
        </Typography>
      </TableCell>
      <TableCell variant='clampedText'
        sx={{ minWidth: '80px' }}>
        {item.productType}
      </TableCell>
      <TableCell variant='clampedText'
        sx={{ minWidth: '80px' }}>
        {item.primaryCategory}
      </TableCell>
      <TableCell>
        {item.pickPackUom}
      </TableCell>
      <TableCell>
        {item.uom}
      </TableCell>
      <TableCell>
        <RoundAndFormatValue value={item.costPrice ?? 0}
          currencyCode={currencyCode} />
      </TableCell>
    </TableRow>
  );
};

export default ItemRow;

